import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';

import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';
import type {
  ChangePlayersStatusRequest,
  ChangePlayersStatusResponse,
  HGChangePlayersStatus,
  HGChangePlayersStatusReply,
  HgGetPlayersBasedOnStatus
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse, useGetClubMembers } from '@swf/poker';

interface Request {
  service: string;
  body: ChangePlayersStatusRequest;
}

interface Props {
  action: HGChangePlayersStatus['action'];
  callbackStatuses: HgGetPlayersBasedOnStatus['statuses'];
  userIds: HGChangePlayersStatus['userIds'];
}

const useChangePlayerStatus = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const request = useRequest();
  const { modal } = useDispatch<Dispatch>();
  const { handleRequest } = useGetClubMembers();
  const handleAction = ({ action, callbackStatuses, userIds }: Props) => {
    request({
      service: 'homeGames.changePlayerStatusRequest',
      body: { changePlayersStatus: { action, clubId: Number(clubId), userIds } }
    } as Request).subscribe({
      next: ({ body }: { body: ChangePlayersStatusResponse }) => {
        const { error } = handleServerResponse<
          ChangePlayersStatusResponse,
          HGChangePlayersStatusReply
        >({
          response: body,
          accessor: 'changePlayersStatusReply'
        });

        if (error) {
          modal.enqueue({
            path: '/notifications/simple-notification',
            locationState: { msg: error }
          });
        } else {
          handleRequest(callbackStatuses);
        }
      }
    });
  };

  return { handleAction };
};

export default useChangePlayerStatus;
